module.exports = __webpack_public_path__ + "static/media/bcf691e5.jpg";